export enum Theme {
  LightBlue = 'lightblue',
  LightPurple = 'lightpurple',
  DarkGreen = 'darkgreen',
  DarkYellow = 'darkyellow',
  DarkTeal = 'darkteal',
}